(function () {
    // -------- State maps --------
    const STATE_TO_CODE = {
        "alabama": "AL", "alaska": "AK", "arizona": "AZ", "arkansas": "AR", "california": "CA",
        "colorado": "CO", "connecticut": "CT", "delaware": "DE", "florida": "FL", "georgia": "GA",
        "hawaii": "HI", "idaho": "ID", "illinois": "IL", "indiana": "IN", "iowa": "IA",
        "kansas": "KS", "kentucky": "KY", "louisiana": "LA", "maine": "ME", "maryland": "MD",
        "massachusetts": "MA", "michigan": "MI", "minnesota": "MN", "mississippi": "MS", "missouri": "MO",
        "montana": "MT", "nebraska": "NE", "nevada": "NV", "new hampshire": "NH", "new jersey": "NJ",
        "new mexico": "NM", "new york": "NY", "north carolina": "NC", "north dakota": "ND", "ohio": "OH",
        "oklahoma": "OK", "oregon": "OR", "pennsylvania": "PA", "rhode island": "RI", "south carolina": "SC",
        "south dakota": "SD", "tennessee": "TN", "texas": "TX", "utah": "UT", "vermont": "VT",
        "virginia": "VA", "washington": "WA", "west virginia": "WV", "wisconsin": "WI", "wyoming": "WY",
        "district of columbia": "DC", "washington dc": "DC", "d.c.": "DC", "dc": "DC",
        "puerto rico": "PR", "guam": "GU", "american samoa": "AS", "u.s. virgin islands": "VI", "virgin islands": "VI", "northern mariana islands": "MP"
    };
    const CODE_TO_STATE = Object.fromEntries(Object.entries(STATE_TO_CODE).map(([k, v]) => [v, k.replace(/\b\w/g, c => c.toUpperCase())]));

    // -------- Selector sets --------
    const SEL = {
        address1: [
            'input[id$="-StreetAddress"]',
            'input[name="address1"]',
            'input[name="address[address1]"]',
            'input[name="shipping_address[address1]"]',
            'input[name="customer[default_address][address1]"]',
            'input[name$="[address1]"]',
            'input[autocomplete="address-line1"]',
            'input[name="customer[note][streetAddress]"]'
        ],
        address2: [
            'input[id$="-StreetAddress2"]',
            'input[name="address2"]',
            'input[name="address[address2]"]',
            'input[name="shipping_address[address2]"]',
            'input[name="customer[default_address][address2]"]',
            'input[name$="[address2]"]',
            'input[autocomplete="address-line2"]',
            'input[name="customer[note][streetAddress2]"]'
        ],
        city: [
            'select[id$="-City"]',
            'input[id$="-City"]',
            'select[name="city"]',
            'input[name="city"]',
            'input[name="address[city]"]',
            'input[name="shipping_address[city]"]',
            'input[name="customer[default_address][city]"]',
            'input[name$="[city]"]',
            'input[autocomplete="address-level2"]',
            'select[name="customer[note][city]"]'
        ],
        zip: [
            'input[id$="-ZipCode"]',
            'input[name="zip"]',
            'input[name="address[zip]"]',
            'input[name="shipping_address[zip]"]',
            'input[name="customer[default_address][zip]"]',
            'input[name$="[zip]"]',
            'input[name$="[postal]"]',
            'input[name*="[postal_code]"]',
            'input[autocomplete="postal-code"]',
            'input[name="customer[note][zip code]"]'
        ],
        province_code: [
            'input[id$="-StateCode"]',
            'input[name="address[province_code]"]',
            'input[name="shipping_address[province_code]"]',
            'input[name="customer[default_address][province_code]"]'
        ],
        province: [
            'select[id$="-State"]',
            'input[id$="-State"]',
            'select[name="state"]',
            'input[name="state"]',
            'select[name="address[province]"]',
            'select[name="shipping_address[province]"]',
            'select[name$="[province]"]',
            'input[name="address[province]"]',
            'input[name="shipping_address[province]"]',
            'input[name$="[province]"]',
            'input[autocomplete="address-level1"]',
            'select[autocomplete="address-level1"]',
            'select[name="customer[note][state]"]'
        ]
    };

    // -------- tiny DOM helpers --------
    const qsAll = (root, arr) => arr.flatMap(sel => Array.from(root.querySelectorAll(sel)));
    const getOne = (root, arr) => (qsAll(root, arr)[0] || null);
    const getVal = (root, arr) => {
        const el = getOne(root, arr);
        return el ? (el.value || "").trim() : "";
    };

    function setVal(el, val) {
        if (!el) return false;
        if (el.tagName === "SELECT") {
            el.value = val ?? "";
            if (el.value !== (val ?? "")) {
                const opt = Array.from(el.options).find(o => (o.text || "").toUpperCase() === String(val || "").toUpperCase());
                if (opt) el.value = opt.value;
            }
            el.dispatchEvent(new Event("change", { bubbles: true }));
        } else {
            el.value = val ?? "";
            el.dispatchEvent(new Event("input", { bubbles: true }));
            el.dispatchEvent(new Event("change", { bubbles: true }));
        }
        return true;
    }

    function setAll(root, arr, val, opts) {
        const skipEmpty = opts && opts.skipEmpty;
        const els = qsAll(root, arr);
        els.forEach(el => {
            if (skipEmpty && (val === null || val === undefined || String(val).trim() === "")) return;
            setVal(el, val);
        });
        return els.length > 0;
    }

    // -------- parsing & normalization --------
    function normalizeStateFromForm(form) {
        const pc = getVal(form, SEL.province_code);
        if (pc) return pc.toUpperCase();
        let s = getVal(form, SEL.province);
        if (!s) return "";
        if (s.length === 2) return s.toUpperCase();
        const code = STATE_TO_CODE[s.toLowerCase()];
        return code ? code : s.toUpperCase();
    }

    function applyState(form, code) {
        if (!code) return;
        setAll(form, SEL.province_code, code);
        const ok = setAll(form, SEL.province, code);
        if (!ok) {
            const name = CODE_TO_STATE[code] || code;
            setAll(form, SEL.province, name);
        }
    }

    function zip5(z) {
        if (!z) return "";
        const m = String(z).match(/\d{5}/);
        return m ? m[0] : "";
    }

    function extractInlineSecondary(a1) {
        if (!a1) return { base: "", sec: "" };
        const rx = /(.*?)(?:\s*,)?\s*(?:#\s*([A-Z0-9\-]+)|\b(?:APT|APARTMENT|UNIT|STE|SUITE|RM|ROOM|FL|FLOOR|BLDG|BUILDING|LOT|TRLR|TRAILER|DEPT|DEPARTMENT)\.?\s*#?\s*([A-Z0-9\-]+))\s*$/i;
        const m = a1.match(rx);
        if (!m) return { base: a1.trim(), sec: "" };
        const id = (m[2] || m[3] || "").toUpperCase();
        const tail = a1.slice(m[1].length);
        const w = tail.match(/\b(apt|apartment|unit|ste|suite|rm|room|fl|floor|bldg|building|lot|trlr|trailer|dept|department)\b/i);
        const word = (w ? w[1] : "APT").toUpperCase();
        return { base: m[1].trim(), sec: `${word} ${id}` };
    }

    // -------- apply USPS suggestion --------
    function applyUSPS(form, a, userSecFallback) {
        const hasA2 = qsAll(form, SEL.address2).length > 0;

        const sec = (a.secondaryAddress && a.secondaryAddress.trim())
            ? a.secondaryAddress.trim()
            : (userSecFallback || "");

        const fullZip = a.ZIPPlus4 ? `${a.ZIPCode}-${a.ZIPPlus4}` : (a.ZIPCode || "");

        if (hasA2) {
            setAll(form, SEL.address1, a.streetAddress, { skipEmpty: true });
            setAll(form, SEL.address2, sec, { skipEmpty: true });
        } else {
            const line1 = sec ? `${a.streetAddress} ${sec}` : a.streetAddress;
            setAll(form, SEL.address1, line1, { skipEmpty: true });
        }

        setAll(form, SEL.city, a.city, { skipEmpty: true });
        applyState(form, a.state);
        setAll(form, SEL.zip, fullZip, { skipEmpty: true });
    }

    function formatSuggested(a) {
        if (!a) return "";
        const zip = a.ZIPPlus4 ? `${a.ZIPCode}-${a.ZIPPlus4}` : (a.ZIPCode || "");
        return `${a.streetAddress}${a.secondaryAddress ? (" " + a.secondaryAddress) : ""}\n${a.city}, ${a.state} ${zip}`;
    }

    // -------- core validate --------
    async function validate(form) {
        const hasAddress = getOne(form, SEL.address1) && getOne(form, SEL.zip);
        if (!hasAddress) return true;

        const a1Raw = getVal(form, SEL.address1);
        const a2Raw = getVal(form, SEL.address2);
        const inline = a2Raw ? { base: a1Raw, sec: "" } : extractInlineSecondary(a1Raw);
        const userSecondary = a2Raw || inline.sec;

        const body = {
            StreetAddress: (inline.base || a1Raw),
            SecondaryAddress: userSecondary,
            City: getVal(form, SEL.city),
            State: normalizeStateFromForm(form),
            ZIPCode: zip5(getVal(form, SEL.zip))
        };

        const r = await fetch("/apps/usps-validate", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(body)
        });

        const raw = await r.text();
        let data = null;
        try { data = raw ? JSON.parse(raw) : null; } catch { }

        if (!r.ok) {
            const msg = data?.error || data?.uspsError || "We couldn’t confirm this address with USPS.";
            return confirm(`${msg}\n\nContinue with your original address?`);
        }

        const a = data?.usps?.address;

        const info =
            data?.usps?.addressAdditionalInfo ||
            data?.usps?.additionalInfo ||
            {};

        const dpv = String(
            info.DPVConfirmation ??
            info.dpvConfirmation ??
            ""
        ).toUpperCase();

        if (dpv === "Y") {
            if (a) {
                applyUSPS(form, a, userSecondary);
            }

            return true;
        }

        let reason =
            "USPS could not fully confirm this address.";

        if (dpv === "D") {
            reason =
                "USPS matched the street but likely needs an apartment/suite (secondary).";
        } else if (dpv === "S") {
            reason =
                "USPS matched the street but the apartment/suite looks invalid.";
        } else if (dpv === "N") {
            reason =
                "USPS could not confirm delivery for this address.";
        }

        const suggested = formatSuggested(a);

        const accepted = confirm(
            `${reason}\n\nSuggested address:\n\n${suggested}\n\nUse this and continue?`
        );

        if (!accepted) {
            return false;
        }

        if (a) {
            applyUSPS(form, a, userSecondary);
        }

        return true;
    }

    // -------- attach: submit hook + click guard --------
    function isSaveButton(el) {
        if (!el) return false;
        const txt = (el.textContent || el.value || "").trim().toLowerCase();
        return /\b(save|update|submit|continue)\b/.test(txt);
    }

    function findFormFor(btn) {
        return btn.form || btn.closest("form") || null;
    }

    function hook(form) {
        if (
            form.matches(".st_shipping-form_JS") ||
            form.matches(".st_billing-form_JS")
        ) {
            return;
        }

        if (form.__uspsHooked) {
            return;
        }

        form.__uspsHooked = true;

        form.addEventListener("submit", async (event) => {
            event.preventDefault();

            try {
                const ok = await validate(form);

                if (ok) {
                    HTMLFormElement.prototype.submit.call(form);
                }
            } catch (error) {
                console.warn("USPS validate error:", error);
                HTMLFormElement.prototype.submit.call(form);
            }
        });
    }


    function waitForAddressFieldsReady(form, timeoutMs = 6000) {
        return new Promise((resolve) => {
            const startedAt = Date.now();

            const check = () => {
                const cityEl = getOne(form, SEL.city);

                const stateEl =
                    getOne(form, SEL.province_code) ||
                    getOne(form, SEL.province);

                const countyEl =
                    form.querySelector(
                        'select[name="county"], input[name="county"]'
                    );

                const cityReady =
                    !cityEl ||
                    (
                        !cityEl.disabled &&
                        String(cityEl.value || "").trim() !== ""
                    );

                const stateReady =
                    !stateEl ||
                    (
                        !stateEl.disabled &&
                        String(stateEl.value || "").trim() !== ""
                    );

                const countyReady =
                    !countyEl ||
                    (
                        !countyEl.disabled &&
                        String(countyEl.value || "").trim() !== ""
                    );

                if (cityReady && stateReady && countyReady) {
                    resolve(true);
                    return;
                }

                if (Date.now() - startedAt >= timeoutMs) {
                    console.warn(
                        "USPS: timeout waiting for ZIP lookup",
                        {
                            cityReady,
                            stateReady,
                            countyReady
                        }
                    );

                    resolve(false);
                    return;
                }

                window.setTimeout(check, 50);
            };

            check();
        });
    }


    function installClickGuard() {
        if (document.__uspsClickGuard) return;

        document.__uspsClickGuard = true;

        document.addEventListener(
            "click",
            async (event) => {
                const target = event.target;

                if (!(target instanceof Element)) {
                    return;
                }

                const btn = target.closest(
                    "button, input[type=submit], input[type=button], [role=button]"
                );

                if (!btn || !isSaveButton(btn)) {
                    return;
                }

                const form = findFormFor(btn);

                if (!form) {
                    return;
                }

                const hasAddress =
                    getOne(form, SEL.address1) &&
                    getOne(form, SEL.zip);

                if (!hasAddress) {
                    return;
                }

                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();

                if (btn.dataset.uspsValidating === "true") {
                    return;
                }

                btn.dataset.uspsValidating = "true";
                btn.disabled = true;

                try {
                    const ok = await validate(form);

                    if (!ok) {
                        return;
                    }


                    /*
                     * USPS may change ZIP to ZIP+4.
                     * This triggers an asynchronous postal-code lookup in the TS class.
                     */
                    await waitForAddressFieldsReady(form);

                    /*
                     * We will not click the Save button again.
                     * We directly inform the TS class that it can save the address.
                     */
                    form.dispatchEvent(
                        new CustomEvent("usps:validated-submit", {
                            bubbles: true,
                            detail: {
                                button: btn
                            }
                        })
                    );
                } catch (error) {
                    console.warn("USPS validate error:", error);

                    /*
                     * Fail-open behavior:
                     * if USPS service is down, still allow TS submit.
                     */
                    form.dispatchEvent(
                        new CustomEvent("usps:validated-submit", {
                            bubbles: true,
                            detail: {
                                button: btn,
                                uspsFailed: true
                            }
                        })
                    );
                } finally {
                    btn.dataset.uspsValidating = "false";
                    btn.disabled = false;
                }
            },
            true
        );
    }

    function scan() {
        document.querySelectorAll("form").forEach(form => {
            const looksLikeAddress = getOne(form, SEL.address1) && getOne(form, SEL.zip);
            if (looksLikeAddress) hook(form);
        });
    }

    document.addEventListener("DOMContentLoaded", () => { scan(); installClickGuard(); });
    installClickGuard();
    scan();
    new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();